const recharge = state => (state.recharge !== null ? state.recharge : {})
const rechargeWelcomeOffer = state => (state.recharge !== null ? state.rechargeWelcomeOffer : {})

export default {
  recharge,
  rechargeWelcomeOffer
}



// WEBPACK FOOTER //
// ./src/store/modules/recharge/getters.js